import { Component } from '@angular/core';
import {CanonicalService} from "./services/canonical.service";
import {MenuComponent} from "./components/menu/menu.component";
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false,
  //imports: [MenuComponent, RouterOutlet]
})
export class AppComponent {

  constructor(private canonicalService: CanonicalService) { }
}
